import styled from 'styled-components';

import { breakpoints, css } from '@notino/react-styleguide';

import { TitleCSS } from '../styled';

export const Title = styled.div`
  ${TitleCSS}
`;

interface IContainerProps {
  withDivider: boolean;
  newPdDesignEnabled: boolean;
}

export const Container = styled.section<IContainerProps>`
  ${({ newPdDesignEnabled }) =>
    !newPdDesignEnabled &&
    css`
      margin: 0 -0.9375rem;
    `}
  box-sizing: border-box;
  display: flex;
  @media (min-width: ${breakpoints.md}) {
    margin: 0;
    border-top: 0;
  }
`;

export const MarginWrapper = styled.div<{ newPdDesignEnabled: boolean }>`
  height: inherit;
  margin: 1rem 0;
  width: 100%;

  @media (min-width: ${({ newPdDesignEnabled }) =>
      newPdDesignEnabled ? breakpoints.lg : breakpoints.md}) {
    margin: 0;
  }
`;
